<template>
  <div class="customer-list-item" @click="$emit('click', $event)">
    <div class="customer-row customer-row-1">
      <span class="customer-id">{{ customer.id }}</span>
      <span class="suffix">@艺爪</span>
    </div>
    <div class="customer-row customer-row-2">
      <span class="external-id">{{ customer.external_id }}</span>
      <span class="suffix">@商户</span>
    </div>
    <div class="customer-row customer-row-3">
      <span class="nickname">{{ customer.nickname || '-' }}</span>
      <span class="date">{{ customer.external_dt_created }}</span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    customer: {
      type: Object,
      required: true,
    },
  },
}
</script>

<style lang="less" scoped>
@import '~@/styles/common';

.customer-list-item {
  cursor: pointer;
  &:hover {
    background: @antBackGrey;
  }
  .customer-row {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    line-height: 1.5;
  }
  .customer-row-1 {
    font-size: 16px;
    font-weight: bold;
    color: @antTextBlack;
  }
  .customer-row-1 .suffix {
    font-size: 14px;
  }
  .customer-row-2,
  .customer-row-3 {
    font-size: 14px;
    color: @antTextGrey;
  }
  .customer-id,
  .external-id,
  .nickname {
    font-family: monospace;
  }
  .date {
    font-size: 13px;
  }
}
</style>
